import '../../CommonStyles.scss';
import Chart from 'chart.js/auto';
import { CategoryScale } from 'chart.js';
import { useGetOrganizationsSummary } from 'queryHooks/Admin/analytics';
import { Bar } from 'react-chartjs-2';
import Paper from '@trackman/web-shared-components/components/Paper/Paper';
import { endValuePlugin } from 'utilities/chartEndValue';
import { options } from '../../consts/barChartConfig';
import { CardHeader } from '../CardHeader/CardHeader';

Chart.register(CategoryScale);

export const StudentsByOrganizationChartCard = () => {
  return (
    <Paper className='analytics-card'>
      <CardHeader title='Students by organization' badges={['DB']} />
      <StudentsByOrganizationChart />
    </Paper>
  );
};

const StudentsByOrganizationChart = () => {
  const NUMBER_OF_ENTRIES = 10;

  const { data: organizations } = useGetOrganizationsSummary();

  const sortedChartEntries = organizations?.sort((a, b) => b.studentsCount - a.studentsCount).slice(0, NUMBER_OF_ENTRIES);

  const labels = sortedChartEntries?.map((entry) => entry.name) ?? [];
  const chartDataset = {
    labels,
    datasets: [
      {
        data: sortedChartEntries?.map((entry) => entry.studentsCount) ?? [],
        backgroundColor: 'rgba(236, 105, 26, 0.7)',
        barThickness: 17,
      },
    ],
  };

  return (
    <div style={{ height: '260px' }}>
      <Bar data={chartDataset} options={options} plugins={[endValuePlugin]} />
    </div>
  );
};
